export const FETCH_LIST_NOTIFICATION_SUCCESS = "FETCH_LIST_NOTIFICATION_SUCCESS";
export const PUSH_NOTIFICATION = "PUSH_NOTIFICATION";

export const STARTUP_NOTIFICATION = "STARTUP_NOTIFICATION";
